import React, { useEffect, memo } from 'react';
import * as Sift from '@sift/types';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useData, useStatus } from 'resift';

// Components
import Loader from 'components/Loader';
import DirectoryMapping from './DirectoryMapping';

// Actions
import makeFieldDirectoryMappingsFetch from 'store/attribute/actions/fieldDirectoryMappingsFetch';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  field: Sift.Field;
}

function Container({ field }: Props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const fieldId = _get(field, 'id', null);
  const fieldDirectoryMappingsFetch = fieldId ? makeFieldDirectoryMappingsFetch(fieldId) : null;

  const fieldData = useData(fieldDirectoryMappingsFetch);
  const status = useStatus(fieldDirectoryMappingsFetch);
  const mappings = _get(fieldData, '_directorySummary', []);

  useEffect(() => {
    if (!fieldData && fieldDirectoryMappingsFetch) {
      dispatch(fieldDirectoryMappingsFetch());
    }
  }, []);

  if (!fieldId) {
    return null;
  }

  return (
    <Loader status={status} classes={{ overlay: classes.overlay }}>
      {() => !!mappings.length && <DirectoryMapping mappings={mappings} />}
    </Loader>
  );
}

const useStyles = makeStyles(() => ({
  overlay: {
    position: 'static',
  },
}));

export default memo(Container);
